import { Outlet } from "react-router-dom";
import Navbar from "../Interface/Menu/Navbar";
import Footer from "../Interface/Footer/Footer";
// import Navbars from "../Interface/Navbar/Navbar";

export const Root = () => {
  return (
    <>
      {/* <Navbars /> */}

      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};
